export default "__VITE_ASSET__qNN13Ndp__"